import Icon from '../components/Icon.vue'

Icon.register({
  dumpster: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 160h-97.3l-25.6-128h98.9c7.3 0 13.7 5 15.5 12.1l24 96c2.5 10.1-5.1 19.9-15.5 19.9zM272 32v128h-126.1l25.6-128h100.5zM404.5 32l25.6 128h-126.1v-128h100.5zM16 160c-10.4 0-18-9.8-15.5-19.9l24-96c1.8-7.1 8.2-12.1 15.5-12.1h98.9l-25.6 128h-97.3zM560 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-28l-20 160v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-320v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16l-20-160h-28c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h20l-4-32h512l-4 32h20z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dumpster.js
// module id = 1290
// module chunks = 0